export const firebaseConfig = {
  apiKey: "AIzaSyDrQTW3DKTGOtJjckuugjGtCdrrir-R99Y",
  authDomain: "mytask-7c4d2.firebaseapp.com",
  projectId: "mytask-7c4d2",
  storageBucket: "mytask-7c4d2.appspot.com",
  messagingSenderId: "816873600210",
  appId: "1:816873600210:web:a74f262e64ef5b2141290b",
  measurementId: "G-DPYNQ3VDTR"
};
